import React from "react";
import { Icon, Popup, PopupContent, PopupHeader } from "semantic-ui-react";
import Barcode from "../../Barcode";
import styles from "./parts.module.css";
import { SkuStock } from "../../../../lib/interfaces/ConveyorBox/IConveyorBox";

type Props = {
  skuId: number;
  varunummer?: string | number | null;
  weight: number;
  stock?: SkuStock;
  showStock?: boolean;
  isLoadingStock?: boolean;
};

const BoxItemSkuInfo = ({ skuId, varunummer, weight, stock, showStock, isLoadingStock }: Props) => {
  return (
    <div className={styles["sku-container"]}>
      <ul className={styles["barcode-list"]}>
        <li>
          <Barcode value={skuId.toString()} prefix="Sku: " formatted={false} />
        </li>

        {varunummer != null && varunummer !== "" && (
          <li>
            <Barcode value={varunummer.toString()} prefix="Vnr: " formatted={false} />
          </li>
        )}
      </ul>

      <div>{weight}g</div>
      {isLoadingStock && showStock && (
        <div className={styles["skeleton"]}>
          <div className={styles["lines"]}>
            <div></div>
          </div>
        </div>
      )}
      {!isLoadingStock && showStock && !stock && (
        <div className={styles["stock-quantity"]}>
          <Icon name="warehouse" />
          <span className={styles["red-text"]}>Misslyckades att hämta lagersaldo</span>
        </div>
      )}
      {!isLoadingStock && showStock && !!stock && (
        <div style={{ width: "min-content" }}>
          <Popup
            trigger={
              <div className={styles["stock-quantity"]}>
                <Icon name="warehouse" />
                {stock.isSuccess ? (
                  stock.totalQuantity > 100 ? (
                    <span>100+</span>
                  ) : stock.totalQuantity > 0 ? (
                    <span>{stock.totalQuantity}</span>
                  ) : (
                    <span className={styles["red-text"]}>Ej i lager</span>
                  )
                ) : (
                  <span className={styles["red-text"]}>Misslyckades att hämta lagersaldo</span>
                )}
              </div>
            }
          >
            <PopupHeader>Lagersaldo</PopupHeader>
            <PopupContent>
              {stock.stockLocations &&
                stock.stockLocations.map((loc) => (
                  <div key={loc.storageLocation}>
                    <p>
                      {loc.storageLocation}: <span>{loc.availableAmount}</span>
                    </p>
                  </div>
                ))}
            </PopupContent>
          </Popup>
        </div>
      )}
    </div>
  );
};

export default BoxItemSkuInfo;
